import { render } from "./MarketingView.vue?vue&type=template&id=453d0aae&scoped=true"
import script from "./MarketingView.vue?vue&type=script&lang=js"
export * from "./MarketingView.vue?vue&type=script&lang=js"

import "./MarketingView.vue?vue&type=style&index=0&id=453d0aae&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-453d0aae"]])

export default __exports__